import styles from "./campaignfilter.module.css";
import { Link } from "react-router-dom";
import { Plus, Search } from "react-feather";

const CampaignFilter = ({ setFilterData }) => {

    return (<div className={`${styles.SearchFilterSec}`}>
        <div className={`${styles.SearchCon}`}>
            <div className={`${styles.SearchConSec}`}>
                <Search />
                <input type="text" placeholder="Search" onChange={(e) => setFilterData((prev) => { return { ...prev, searchKey: e.target.value }; })} />
            </div>
        </div>
        <div className={`${styles.FilterSec}`}>
            <Link to={`/campaign/campaigns/add`} className={`${styles.AddNoteBu}`}>
                <Plus /> <span>Template</span>
            </Link>
        </div>
    </div>);
}

export default CampaignFilter;